<template lang="tr">
  <div lang="tr" class="vertical-align-step-0 pb-4">

   
      <span class="product-header-field">{{$t('Vergi Paketi aboneliği satın almak ister misiniz')}}</span>
      
      <div v-if="mainPackage && mainPackage.id">
        <div @click="changeMainPackage(mainPackage.code)" class="box-border2 selectable-field"
          v-bind:class="{ 'selected': isSelectedMainPackage }">
          <div class="box-content-field">
            <div>
              
              <div class="new-product-top-field">
                <div class="new-product-top-field-inside">
                  <div class="check-field" />
                
                  <span class="new-product-name">{{getProductName(mainPackage)}}</span>
                </div>
                <div class="new-badge-field">{{ $t('Yeni Paket') }}</div> 

              </div>

             
           
            </div>
            <span class="new-product-description">{{getProductDescription(mainPackage)}}</span>

            <div class="">

              <ul
                    class="vertical-center features-spacing main-feature mt-4 features-half"
                  >
                    <li
                      v-for="feature in packageFeatures"
                      :key="feature.text"
                      class="col-12"
               
                    >
                      <span class="d-flex align-items-start feature-item">
                        <span  class="feature-text">{{ feature.text }}</span>
                        <i
                          v-if="feature.tooltipOptions"
                          v-tippy="feature.tooltipOptions.text"
                          class="fa fa-info-circle feature-icon"
                        ></i>
                      </span>

                    </li>
                  </ul>

           
            </div>

            <hr />

            <div class="new-product-bottom-field">
              <div class="bottom-left-field">
                <div class="old-price-field overline"> 
                  <span class="old-price">{{formatPrice(898, '$')}} </span> 
                  <span class="fee-text"> {{
                    mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
                <div class="new-price-field"> 
               
                  <span class="new-price">{{ formatPrice(mainPackage.net_price,mainPackage.currency)}} </span> 
                  <span class="fee-text"> {{
                    mainPackage.type === 'subscription' ? (mainPackage.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
                  }}</span>
                </div>
              </div>

              <div class="bottom-right-field">
                <div class="price-badge-field">
                  <img src="/img/icons/lightning.svg" alt="price-badge" />
                  <span class="ml-1">{{$t('daha tasarruflu', {price: '%22'})}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

  

      <div class="additional-product" v-for="(product,index) in mainPackageChildProducts" :key="index">
        <span class="product-name-field">{{getProductName(product)}}</span>
        <div class="additional-product-right-field">
          <span class="price-text-field overline">{{formatPrice(product.net_price, product.currency)}}</span>
          <span class="colorful-text-field">{{$t('Vergi Paketi ile Ücretsiz')}}</span>
        </div>
      </div>

    

    <div v-if="isSelectedMainPackage && franchiseTaxProduct.code">
      <hr/>
    <span class="product-header-field">{{$t('İmtiyaz Vergisi ödemenizi bizim takip edip ödememizi ister misiniz')}}</span>

    <div class="additional-product-selectable selectable-field  green-selectable-field" :class="{'selected': isSelectedFranchiseTax}" @click="isSelectedFranchiseTax = !isSelectedFranchiseTax" >
      <div class="additional-product-left-field">
        <div class="circle-field relative rounded-full">
          <div class="inner-circle-field" />
        </div>
        <span class="product-name-field">{{getProductName(franchiseTaxProduct)}}</span>
        <div>
          <i v-tippy="{content: $t('Şirketinizin kurulu olduğu eyalete ödenecek yıllık imtiyaz vergisi ödemesi ve hizmet bedelini içerir')}" class="fa fa-info-circle mr-2 alert-icon-size alert-icon-spacing alert-icon-warning"></i>
        </div>
      </div>
      
      <div class="additional-product-right-field">
        <span class="price-text-field">{{formatPrice(franchiseTaxProduct.net_price, franchiseTaxProduct.currency)}}</span>
        <span class="price-period-field">{{
          franchiseTaxProduct.type === 'subscription' ? (franchiseTaxProduct.period === 'annual' ? ' /' + $t('Yıl') : ' /' + $t('Ay')) : ''
        }}</span>
      </div>
    </div>
  </div>
    <usTaxPackageConfirmationModal :us-products="usProducts" :company="company" @confirm="sendForm"  ref="usTaxPackageConfirmationModal"/>
    <usTaxConfirmationModal :features="usTaxConfirmFeatures" @confirm="taxConfirmationConfirm" @cancel="taxConfirmationCancel"  ref="usTaxConfirmationModal"/>
  </div>
</template>

<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import usTaxConfirmationModal from '../../modals/usTaxConfirmation.vue';
import usTaxPackageConfirmationModal from '../../modals/usTaxPackageConfirmation.vue';

export default {
  computed: {},
  components: {
    usTaxPackageConfirmationModal,
    usTaxConfirmationModal,
  },
  props: {
    states: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
    usProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      mainPackageChildCodes: ['USITIN_IN_PACKAGE', 'US_FORMATION_PACKAGE'],
      products: [],
      company: {
        global_activity_area: null,
      },
      isSelectedMainPackage: false,
      isSelectedFranchiseTax: false,
      mainPackage: {},
      packageFeatures: this.$t('Us Tax Maddeleri'),
      mainPackageChildProducts: [],
      franchiseTaxProduct: {},
      callback: null,
      usTaxConfirmFeatures: this.$t('Us Tax Confirmation Maddeleri'),
    };
  },
  created() {
    CompanyStore.dispatch('getCompany').then((s) => {
      this.endWaiting();
      if (s.data.data.length) {
        this.company = s.data.data[0];

        if (this.company.package) {
          if (this.company.package.includes('US_TAX_PACKAGE_PRODUCT')) {
            this.isSelectedMainPackage = true;
          }
        }

        const uppercaseState = this.company.state.toUpperCase();
        const selectedStateProducts = this.usProducts.filter(function (item) {
          if (item.code.includes(uppercaseState)) {
            return true;
          }
          return false;
        });
        if (selectedStateProducts.length) {
          const franchiseTaxProduct = selectedStateProducts.find((x) => x.code.includes('FRANCHISETAX'));
          if (franchiseTaxProduct) {
            franchiseTaxProduct.net_price = this.getPrice(franchiseTaxProduct.prices.data);
            this.franchiseTaxProduct = franchiseTaxProduct;
          }

          if (this.company.package) {
            if (this.company.package.includes(this.franchiseTaxProduct.code)) {
              this.isSelectedFranchiseTax = true;
            }
          }
        }

        const mainPackage = this.usProducts.find((element) => element.code === 'US_TAX_PACKAGE_PRODUCT');

        if (mainPackage) {
          mainPackage.net_price = this.getPrice(mainPackage.prices.data);
          this.mainPackage = mainPackage;
        }

        this.mainPackageChildProducts = this.mainPackageChildCodes
          .map((code) => this.usProducts.find((item) => item.code === code))
          .filter((item) => item);

        this.mainPackageChildProducts = this.mainPackageChildProducts.map((item) => ({
          ...item,
          net_price: this.getPrice(item.prices.data),
        }));
      }
    });
  },

  methods: {
    taxConfirmationCancel() {
      this.sendForm();
    },
    taxConfirmationConfirm() {
      this.isSelectedMainPackage = true;
      this.$refs.usTaxPackageConfirmationModal.calculateProducts();
      if (this.$refs.usTaxPackageConfirmationModal.getProductsArray().length) {
        const element = this.$refs.usTaxPackageConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.sendForm();
      }
    },
    changeMainPackage() {
      this.isSelectedMainPackage = !this.isSelectedMainPackage;
    },
    getPrice(prices) {
      const price = prices.find((x) => x.company_type_id === this.company.company_type_id).price;
      return price;
    },
    sendForm() {
      let packageData = [];
      if (Array.isArray(this.company.package)) {
        packageData = [...this.company.package];
      }

      const removeArray = [
        this.mainPackage.code,
        'USITIN_IN_PACKAGE',
        'US_1040_NR_FORM',
        'USITIN',
        'US_1065_FORM',
        'US_1120_FORM',
        'USFRANCHISETAX_DELAWARE_NEW',
        'USFRANCHISETAX_FLORIDA_NEW',
        'USFRANCHISETAX_WYOMING_NEW',
      ];

      packageData = packageData.filter((item) => !removeArray.includes(item));

      if (this.isSelectedMainPackage) {
        packageData.push(this.mainPackage.code);
        packageData.push('USITIN_IN_PACKAGE');
        if (this.isSelectedFranchiseTax && this.franchiseTaxProduct.code) {
          packageData.push(this.franchiseTaxProduct.code);
        }
      }

      const taxProducts = this.$refs.usTaxPackageConfirmationModal.getProductsArray();
      if (taxProducts && taxProducts.length) {
        packageData = packageData.concat(taxProducts);
      }

      this.startWaiting();
      RegisterStore.dispatch('package', {
        packages: packageData,
      }).then((s) => {
        if (s.data.success === false) {
          this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
          this.endWaiting();
          return;
        }

        this.$store.commit('setCompanyId', s.data.data.id);
        this.callback(true);
      });
    },
    openSummaryModal(callback) {
      this.callback = callback;

      if (!this.isSelectedMainPackage) {
        const element = this.$refs.usTaxConfirmationModal.$el;
        $(element).modal('show');
      } else {
        this.$refs.usTaxPackageConfirmationModal.calculateProducts();
        if (this.$refs.usTaxPackageConfirmationModal.getProductsArray().length) {
          const element = this.$refs.usTaxPackageConfirmationModal.$el;
          $(element).modal('show');
        } else {
          this.sendForm();
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box-content-field {
  padding: 24px 0px;
  color: #4b5563;
  flex-wrap: wrap;

  .main-features {
    font-size: 15px;
  }

  .features-spacing {
    margin-top: 1rem;
  }

  .features-full,
  .features-half,
  .features-additional-half {
    li {
      margin-bottom: 6px;
    }
  }

  .features-half,
  .features-additional-half {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;

    li {
      flex-basis: calc(50% - 10px);
      max-width: calc(50% - 10px);
      padding: 0.5rem;
      background: #f1fafe;
      border-radius: 0.25rem;

      .feature-item {
        flex-flow: wrap;

        .feature-text {
          width: calc(100% - 32px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      @media (max-width: 576px) {
        flex-basis: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
